import type { TopStrategyParams } from "../TopStrategyTuner.types";
import type { AdNodeManager } from "../../../core/AdNodeManager";
import type { SlotManagerFeature } from "../features/SlotManagerFeature";

export class SlotManagerFeatureActivator {
  private activating: boolean = false;
  private feature?: SlotManagerFeature;

  constructor(private readonly adNodeManager: AdNodeManager) {}

  activate(options: Pick<TopStrategyParams, "enabledSlots">) {
    if (this.activating || this.feature) {
      return;
    }

    this.activating = true;

    import("../features/SlotManagerFeature")
      .then(({ SlotManagerFeature }) => {
        this.feature = new SlotManagerFeature(this.adNodeManager);
        this.feature.activate(options.enabledSlots ?? []);
        this.activating = false;
      })
      .catch(() => {
        this.activating = false;
        throw new Error("Failed to load SlotManagerFeature");
      });
  }
}
